'use client';

import { useEffect, useRef } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { useIntl } from 'react-intl';
import { useExperiments, useExposureEvent } from '@alltrails/experiments';
import useUser from '@alltrails/context/hooks/useUser';
import { useSelector } from 'react-redux';
import Footer from '../Footer';

type FooterWrapperProps = {
  pageReloadOnLanguageChange?: boolean;
};

const FooterWrapper = ({ pageReloadOnLanguageChange }: FooterWrapperProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const irclickid = useSelector((state: { irclickid: string }) => state.irclickid);
  const intl = useIntl();
  const experiments = useExperiments();
  const hasByotExperiment = experiments['web-discover-byot-phase2-rm']?.value === 'treatment';
  const sendBYOTExposure = useExposureEvent('web-discover-byot-phase2-rm');
  const container = useRef<HTMLDivElement>(null);
  const hasLoggedBYOTExposure = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasLoggedBYOTExposure.current) {
            hasLoggedBYOTExposure.current = true;
            sendBYOTExposure();
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    if (container.current) {
      observer.observe(container.current);
    }

    return () => observer.disconnect();
  }, [hasLoggedBYOTExposure, sendBYOTExposure]);

  return (
    <div ref={container}>
      <Footer
        intl={intl}
        user={user}
        wideFooter={false} // only explore pages use a wide footer
        languageRegionCode={languageRegionCode}
        irclickid={irclickid}
        pageReloadOnLanguageChange={pageReloadOnLanguageChange}
        hasByotExperiment={hasByotExperiment}
      />
    </div>
  );
};

export default FooterWrapper;
